import 'css-chunksrc/client/common/filterMenu/scrollPane/styles.scss';export default {
  "scrollPane": "_scrollPane_45kk0_1"
};